var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.001,
    height: 76.836,
    viewBox: "0 0 84.001 76.836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(-35.221 28.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M35.221,31.946c.417-3.822,2.443-6.959,4.313-10.165,1.582-2.715,3.147-5.439,4.719-8.16q9.9-17.141,19.8-34.286a15.1,15.1,0,0,1,10.634-7.726c5.407-1.055,11.782,1.418,14.682,6.1,3.108,5.014,6,10.164,8.953,15.272q9.34,16.14,18.654,32.3a15.017,15.017,0,0,1-13,22.918c-7.932.026-15.864.006-23.8.006q-14.811,0-29.622,0a14.7,14.7,0,0,1-11.875-5.442A14.981,14.981,0,0,1,35.366,35.2c-.031-.211-.1-.417-.145-.625Zm41.871,9.476q13.289,0,26.578,0a8.532,8.532,0,0,0,5.78-1.918,8.2,8.2,0,0,0,1.714-10.74Q100.806,10.807,90.432-7.142c-2.146-3.713-4.217-7.473-6.494-11.1a7.508,7.508,0,0,0-7.526-3.529A8.013,8.013,0,0,0,69.983-17.4Q59.51.773,49,18.927c-2.062,3.571-4.2,7.1-6.128,10.747a7.6,7.6,0,0,0,.532,8.094,8.075,8.075,0,0,0,7.275,3.657Q63.885,41.414,77.092,41.422Z",
    fill: "#fc8383"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M217.736,85.759c-.33,5.681-.663,11.407-1,17.134a19.721,19.721,0,0,1-.16,2.445,3.147,3.147,0,0,1-3.123,2.512,3.015,3.015,0,0,1-3.109-2.595c-.25-2.195-.329-4.409-.467-6.616-.271-4.334-.51-8.671-.8-13-.212-3.139,2.062-5.562,4.952-5.205a4.254,4.254,0,0,1,3.7,3.892C217.765,84.784,217.736,85.25,217.736,85.759Z",
    transform: "translate(-136.238 -85.442)",
    fill: "#fc8383"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M209.6,225.3a4.329,4.329,0,0,1,4.364-4.271,4.3,4.3,0,0,1-.065,8.6A4.309,4.309,0,0,1,209.6,225.3Z",
    transform: "translate(-136.655 -195.656)",
    fill: "#fc8383"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteError);
export default __webpack_public_path__ + "static/media/delete_error.6f0217bbee1a631c68d86281d4257af5.svg";
export { ForwardRef as ReactComponent };